import { render, staticRenderFns } from "./profile-image.vue?vue&type=template&id=23cfffbb&scoped=true&"
import script from "./profile-image.vue?vue&type=script&lang=js&"
export * from "./profile-image.vue?vue&type=script&lang=js&"
import style0 from "./profile-image.vue?vue&type=style&index=0&id=23cfffbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cfffbb",
  null
  
)

export default component.exports